import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import MfaChallengeDto from "types/MfaChallengeDto";

interface MfaResendPayload {
  challengeToken: string;
}

export default function usePostMfaResend() {
  const { write, ...rest } = useApiWrite();

  const postMfaResend = (payload: MfaResendPayload): Promise<MfaChallengeDto> =>
    write<MfaChallengeDto>({
      url: endpoints.postMfaResend(),
      method: HTTP_METHOD.POST,
      data: payload,
    }).then(({ data }) => data);

  return {
    postMfaResend,
    ...rest,
  };
}
